import { useState } from 'react';
import { categories, getMoviesByCategory } from '@/mocks/movies';
import MovieCard from '@/components/feature/MovieCard';

export default function CategoryPreview() {
  const [activeCategory, setActiveCategory] = useState('movie');
  const movies = getMoviesByCategory(activeCategory).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-6">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">
            <i className="ri-stack-line text-primary-500 mr-2"></i>
            分类速览
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按类型发现你喜欢的影视内容</p>
        </div>

        <div className="flex items-center gap-2 mb-6 overflow-x-auto pb-2">
          {categories.filter((c) => c.slug !== 'all').map((cat) => (
            <button
              key={cat.slug}
              onClick={() => setActiveCategory(cat.slug)}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                activeCategory === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200'
              }`}
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.label}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {movies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>

        <div className="mt-6 text-center">
          <Link
            to={`/category/${activeCategory}`}
            className="inline-flex items-center gap-1 px-6 py-2.5 rounded-lg bg-background-50 text-foreground-800 text-sm font-medium border border-background-300 hover:border-primary-300 hover:text-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            查看更多{activeCategory === 'movie' ? '电影' : activeCategory === 'tv' ? '电视剧' : activeCategory === 'variety' ? '综艺' : '动漫'}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}